import { Row } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';
import { IconTrendingDown } from '@tabler/icons-react';
import type { PriceCut } from 'components/marketplace/helpers/certaintyPanel';
import { formatCurrency } from 'helpers/formatters';

export const PriceCutHeadline = ({ price, priceCut }: { price: string; priceCut: PriceCut }) => {
  const cutPercent = ((priceCut.cutCents / priceCut.originalListPriceCents) * 100).toFixed(1);

  return (
    <Row className="flex-wrap items-baseline justify-between gap-x-4 gap-y-1 pb-6">
      <Row className="items-baseline gap-3">
        <Text as="h2" className="text-header-md text-od-content-primary">
          {price}
        </Text>
        <Text as="span" className="text-subheader-sm text-od-content-tertiary line-through">
          {formatCurrency(priceCut.originalListPriceCents)}
        </Text>
      </Row>
      <Row className="items-center gap-1.5">
        <IconTrendingDown size={18} className="text-od-content-success" />
        <Text as="span" className="text-body-md font-medium text-od-content-success">
          {formatCurrency(priceCut.cutCents)} price cut ({cutPercent}%)
        </Text>
      </Row>
    </Row>
  );
};
